import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LoadingModal from "../components/Modals/LoadingModal/LoadingModal";
import { useCustomer } from "../customHooks/useCustomer";

interface ProtectedAuthRoutesProps {
  children: any;
}

// If: customer logged in -> navigate to MyAccount
// else: let him use the auth route and login / register

const ProtectedAuthRoutes: React.FC<ProtectedAuthRoutesProps> = ({ children }) => {
  const { country } = useParams(); // Get the "country" parameter from the URL
  const navigate = useNavigate(); 
  const { customerState } = useCustomer();
  const fullURL = window.location.href;
  const redirectParam = '?redirect=';
  
  useEffect(() => {
    
    if (customerState?.customerID) {
      if(fullURL.includes(redirectParam)) {
        const redirectTo = decodeURIComponent(fullURL.split(redirectParam)[1]);
        navigate(redirectTo);
      } else {
        navigate(`/${country}/account/my-orders`);
      }
    }
  }, [customerState, navigate, country]);

  if (customerState?.customerID){
    return <LoadingModal /> //load until it navigates (this line happens pre useeffect)

  } else {
    return children;
  }

};

export default ProtectedAuthRoutes;
